/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UpdateReminderModal from 'ui/components/meetings/reminders/UpdateReminderModal.vue';
import UpdateReminderBeforeTimeModal from 'ui/components/meetings/reminders/UpdateReminderBeforeTimeModal.vue';

const DEFAULT_CONFIG = {
    time: '08:00',
    // 'same_day' | 'day_before'
    when: 'same_day',
};

const __vue_script__ = {
    name: 'ReminderCard',

    components: {
        UpdateReminderModal,
    },

    props: {
        type: {
            type: String,
            required: true
        },

        value: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            config: {
                ...DEFAULT_CONFIG,
                ...this.value,
            },
        };
    },

    computed: {
        formattedTime() {
            if (!this.config.time) {
                return '';
            }

            if (this.type === 'all') {
                return this.$utils.time.humanizeTimeLeft(this.$utils.time.toSeconds(this.config.time, 'hh:mm'), this.$i18n.locale);
            }

            const [hours, minutes] = this.config.time.split(':').map(Number);

            return this.$utils.time.formatTime({
                hours,
                minutes,
                format: 'LT',
            });
        }
    },

    watch: {
        value: {
            handler(newValue) {
                this.config = {
                    ...DEFAULT_CONFIG,
                    ...newValue,
                };
            },
            deep: true
        }
    },

    methods: {
        handleClick() {
            const component = this.type === 'all' ? UpdateReminderBeforeTimeModal : UpdateReminderModal;

            this.$modal.show(component,
                {
                    config: this.config,
                    type: this.type,
                    saveHandler: (v) => {
                        this.config.when = v.when;
                        this.config.time = v.time;

                        this.$emit('input', this.config);
                    },
                },
                {
                    classes: 'small',
                    height: 'auto',
                    reset: true,
                    clickToClose: false
                },
            );
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reminder-card boxed-content" }, [
    _c("div", { staticClass: "header" }, [
      _c("i", { staticClass: "ic-clock" }),
      _c("span", [
        _vm._v(
          _vm._s(_vm.$t("meetings.settings.communication.reminders.send_time"))
        ),
      ]),
    ]),
    _c("div", { staticClass: "body" }, [
      _c("i", { staticClass: "ic-clock" }),
      _vm.type !== "all"
        ? _c("div", { staticClass: "time" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "meetings.settings.communication.reminders." +
                      _vm.config.when
                  )
                ) + ":"
              ),
              _c("strong", [_vm._v(" " + _vm._s(_vm.formattedTime) + ".")]),
            ]),
          ])
        : _c("div", { staticClass: "time-before" }, [
            _c("strong", [_vm._v(_vm._s(_vm.formattedTime))]),
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "meetings.settings.communication.reminders.duration_before"
                    )
                  )
              ),
            ]),
          ]),
      _c(
        "button",
        { staticClass: "btn btn-default", on: { click: _vm.handleClick } },
        [_vm._v(_vm._s(_vm.$t("general.update")))]
      ),
    ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/reminders/ReminderCard.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__